import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "animate.css/animate.css";
import "font-awesome/css/font-awesome.css";
import logo from "./logo.svg";
import "./Signup.css";
import Session from "react-session-api";
import { useState } from "react";
import axios from "axios";
import ReturnClass from "./ReturnClass";
import { useNavigate } from "react-router-dom";


export default function Verifyotp() {
    debugger;
    const apiurl = window.SERVICE_URL;

    const IsVerifyOtpFor = {
        IsVerifyOptions: 0

    }
    const navigate = useNavigate();
    const showHideControls = {
        IsMobileVerification: { display: 'none' },
        IsEmailVerification: { display: 'none' }
    }

    if (localStorage.getItem("usersession") != null) {
        const ress = JSON.parse(localStorage.getItem("usersession"));
        ReturnClass.EmailID = ress.EmailID;
        ReturnClass.MobileNumber = ress.MobileNumber;
        ReturnClass.PartnerID = ress.PartnerID;
        ReturnClass.ID = ress.ID;
    }

    if (localStorage.getItem("VerifyOptions") != null) {

        const verification = JSON.parse(localStorage.getItem("VerifyOptions"));
        var IsEmailVerification = verification.IsEmailVerification;
        var IsMobileVerification = verification.IsMobileVerification;

        if (IsEmailVerification) {
            showHideControls.IsEmailVerification = { display: 'block' };
            IsVerifyOtpFor.IsVerifyOptions = 2;
        }
        if (IsMobileVerification) {
            showHideControls.IsMobileVerification = { display: 'block' };
            IsVerifyOtpFor.IsVerifyOptions = 1;
        }
    }


    const verifyOTPUser = async (e) => {
        e.preventDefault();
      debugger;
        var IsMobile = document.getElementById("txtMobile").value;
        var Isemail = document.getElementById('txtEmailID').value;

        const sendOTPClass = {
            PartnerID: ReturnClass.PartnerID.toLocaleString(),
            OTPMobile: IsMobile,
            OTPEmail: Isemail,
            AddedOn: new Date(),
            IsUsed: false,
            VerifiedOn: new Date(),
            OTPFor: IsVerifyOtpFor.IsVerifyOptions,
            UserID: ReturnClass.PartnerID,
            VerifyOTPFor: 1,
            MobileNo: ReturnClass.MobileNumber,//returnclass.MobileNumber,
            EmailID: ReturnClass.EmailID//returnclass.EmailID
        }

      //  debugger;
        await axios.post(apiurl + `api/VerifyOTP`, sendOTPClass, {
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then((result) => {
                debugger;
                navigate('/');
            })

    }

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-4 px-5 py-2 d-flex justify-content-center align-items-center">
                        <div>
                            <center>
                                <img src={logo} alt="brand-logo" className="w-50 mb-3" />
                            </center>

                            <form>
                                <div className="form-outline mb-3" style={showHideControls.IsMobileVerification}>
                                    <label className="form-label" htmlFor="mobile-otp" >
                                        Mobile OTP
                                    </label>
                                    <input type="text" id="txtMobile" name="mobile-otp" className="form-control" placeholder="Enter here Mobile OTP" />
                                </div>
                                <div className="form-outline mb-3" style={showHideControls.IsEmailVerification}>
                                    <label className="form-label" htmlFor="email-otp">
                                        Email OTP
                                    </label>
                                    <input type="text" id="txtEmailID" className="form-control" placeholder="Enter here Email OTP" name="email-otp" />
                                </div>
                                <button
                                    type="button"
                                    className="btn btn-primary btn-block mb-3" onClick={verifyOTPUser}
                                >
                                    Verify OTP
                                </button>
                            </form>
                        </div>
                    </div>
                    <div className="col-md-8 rightbox">
                        <h3 className="title mt-3">Welcome to Questopedia</h3>
                        <div className="yoc-login__desc">
                            The Question Paper Generator Platform{" "}
                        </div>
                        <h6 className="brand-title" align="center">
                            Questopedia provides the services to care for business
                        </h6>

                        <div className="row mt-5">
                            <div className="col-md-4">
                                <div className="feature-box">
                                    <div className="iconbox">
                                        <i className="fa fa-newspaper-o"></i>
                                    </div>
                                    <h4 className="featureheading">faeture 1</h4>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="feature-box">
                                    <div className="iconbox">
                                        <i className="fa fa-newspaper-o"></i>
                                    </div>
                                    <h4 className="featureheading">faeture 2</h4>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="feature-box">
                                    <div className="iconbox">
                                        <i className="fa fa-newspaper-o"></i>
                                    </div>
                                    <h4 className="featureheading">faeture 3</h4>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="feature-box">
                                    <div className="iconbox">
                                        <i className="fa fa-newspaper-o"></i>
                                    </div>
                                    <h4 className="featureheading">faeture 4</h4>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="feature-box">
                                    <div className="iconbox">
                                        <i className="fa fa-newspaper-o"></i>
                                    </div>
                                    <h4 className="featureheading">faeture 5</h4>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="feature-box">
                                    <div className="iconbox">
                                        <i className="fa fa-newspaper-o"></i>
                                    </div>
                                    <h4 className="featureheading">faeture 6</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}